const collectionMainListSwiper = document.querySelector('.js-collection-swiper')

const collectionMainListSwiperInit = new Swiper(collectionMainListSwiper, {
  effect: "fade",
  direction: "vertical",
  loop: true,
  spaceBetween: 0,
  grabCursor: false,
  slidesPerView: 1,
  mousewheel: true,
  // mousewheel: {
  //   releaseOnEdges: true,
  // },
  pagination: {
    el: ".collection-swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + '0' + (index + 1) + "</span>";
    }
  }
  // on: {
  //   init: function () {
  //     ScrollTrigger.refresh();
  //   },
  // },
});
